import { Steps as StepsA, type StepsProps } from 'antd';
import { useMemo } from 'react';

type P = {
  currentStep: number;
  numberOfSteps: number;
  onChange?: (step: number) => void;
};

const Steps = ({ currentStep, numberOfSteps, onChange }: P) => {
  const items: StepsProps['items'] = useMemo(
    () => [...Array.from({ length: numberOfSteps }).keys()].map(() => ({})),
    [numberOfSteps],
  );

  return <StepsA className="steps" current={currentStep} items={items} onChange={onChange} />;
};

export default Steps;
